import store, { registerIfNotExist, unregisterIfExists } from '@/store'
import { fetchSingleTarget, notifyAdCity } from '@/api'
import { createModule } from '@/appComponents/workbench/targetDefinition'
import definitionSerializer from '@/appComponents/workbench/targetDefinition/services/serializer'
import { SET_DEFINITION, SET_VIEW_ONLY } from '@/appComponents/workbench/targetDefinition/store/actions'
import { validateTargetName } from '@/appLogic/targets/TargetLogic'
import { actions as undoActions } from '@/store/plugins/undoHistory'
import { GO_TO_DASHBOARD as GO_TO_DASHBOARD_ROUTES } from '@/router/store/actions'
import transformAttributes from '@/appLogic/workbench/common/attributeTransformation'
import { cloneDeep } from 'lodash'
import { flatten } from '@/helpers'

const module = 'COMMON_WORKBENCH_ACTIONS_'
export const STORE_NAME = 'workbench'
export const SET_ATTRIBUTES = module + 'SET_ATTRIBUTES'
export const SET_FAMILY_ATTRIBUTES = module + 'SET_FAMILY_ATTRIBUTES'
export const RESET_FAMILY_DATASETS = module + 'RESET_FAMILY_DATASETS'
export const SET_INTERFACE = module + 'SET_INTERFACE'
export const ON_CREATE_ACTION = module + 'ON_CREATE_ACTION'
export const SET_TARGET_CREATE_ACTION = module + 'SET_TARGET_CREATE_ACTION'
export const SET_TARGET = module + 'SET_TARGET'
export const ON_CREATE_REGISTER_MODULES_TO_STORE = module + 'ON_CREATE_REGISTER_MODULES_TO_STORE'
export const ON_RESET_UNREGISTER_MODULES_TO_STORE = module + 'ON_RESET_UNREGISTER_MODULES_TO_STORE'
export const UPDATE_TARGET_DEFINITION_RELATED_INFORMATION = module + 'UPDATE_TARGET_DEFINITION_RELATED_INFORMATION'
export const SET_SLOTTED_VALUE = module + 'SET_SLOTTED_VALUE'
export const SAVE_TARGET = module + 'SAVE_TARGET'
export const SET_ENABLE_SAVE_BUTTON = module + 'SET_ENABLE_SAVE_BUTTON'
export const SET_ENABLE_DOWN_STREAM = module + 'SET_ENABLE_DOWN_STREAM'
export const SET_ENABLE_DEFINITION_ACTIONS = module + 'SET_ENABLE_DEFINITION_ACTIONS'
export const SUBMIT_DOWNSTREAM = module + 'SUBMIT_DOWNSTREAM'
export const SET_TARGET_DEFINITION = module + 'SET_TARGET_DEFINITION'
export const QUERY_FOR_DATA = module + 'QUERY_FOR_DATA'
export const SET_TARGET_DEFAULT = module + 'SET_TARGET_DEFAULT'
export const SET_LOADING_WORKBENCH = module + 'SET_LOADING_WORKBENCH'
export const SET_TARGET_DEFINITION_DIRTY = module + 'SET_TARGET_DEFINITION_DIRTY'
export const RESET_STORE = module + 'RESET_STORE'
export const INITIALIZE_TARGET_DEF = module + 'INITIALIZE_TARGET_DEF'
export const CLEAR_ATTRIBUTES = module + 'CLEAR_ATTRIBUTES'
export const GO_TO_DASHBOARD = module + 'GO_TO_DASHBOARD'
// TODO_AFTER SHOW_AUP_MODAL is Xandr specific only, should be in the Xandr store
export const SHOW_AUP_MODAL = module + 'SHOW_AUP_MODAL'
export const SET_ADVERTISER = module + 'SET_ADVERTISER'
export const SET_DATASET_FAMILY = module + 'SET_DATASET_FAMILY'
export const UPDATE_TARGET_NAME = module + 'UPDATE_TARGET_NAME'
export const SET_AVAILABLE_DESTINATIONS = module + 'SET_AVAILABLE_DESTINATIONS'
export const NOTIFY_ADCITY = module + 'NOTIFY_ADCITY'
export const MODEL_LAL = module + 'MODEL_LAL'

/**
 * THis is what the LAS is doing currently in the old Workbench version
 * 1. set the loading
 * 2. get the configs, get the revision history, get the target
 *    a. the configs is not the same as the datasets
 * 3. set the current target
 * 4. set the target branch (revision history)
 * 5. set the default viewing_stream to lsd
 * 6. manage some more revision history things
 * 7. if the target is Activated, set the screen to view only
 * 8. fetch the attributes and the networks
 * 9. set the data Sources, quick adds, networks, and network groupings, day parts, and date range
 * 10. set the target definition
 * 11. update the viewing stream
 * 12. set the selected viewership networks
 * 13. then fetch the data needed for the graphs
 *
 *
 * important things to mention
 * must have '@/appLogic/targets/currentTarget/store/actions'
 */

const actions = {
  [ON_CREATE_REGISTER_MODULES_TO_STORE]: context => {
    // these are the stores that need to be registered for the Workbench to work.
    registerIfNotExist([STORE_NAME, 'targetDefinition'], () => {
      return createModule(STORE_NAME)
    })
  },
  [ON_RESET_UNREGISTER_MODULES_TO_STORE]: context => {
    unregisterIfExists([STORE_NAME, 'targetDefinition'])
  },
  [RESET_FAMILY_DATASETS]: context => {
    // if information is missing from the newTargetDefintion, it goes through a filter for each of the values on the
    // TD.  look at this serializer src/app/appComponents/workbench/targetDefinition/services/serializer.js
    let validDatasets = Object.keys(context.rootState.appRes.datasetFamilies.datasetRelationships)
    const td = context.getters.newTargetDefinition
    const wbTarget = context.getters.newWorkbenchTarget
    let tdFlattened = flatten(td)
    let datasets = tdFlattened.map(x => x.rootFamily).filter(x => x !== undefined && validDatasets.includes(x))
    if (datasets.length === 0) {
      datasets = tdFlattened.map(x => x.dataset).filter(x => x !== undefined && validDatasets.includes(x))
    }
    // we could add the familydata (as the rootDataset to each attribute as well)
    const setFamilyAttributesPayload = {
      context,
    }
    if (td.length === 0) {
      // set the family attributes to null
      setFamilyAttributesPayload.family = null
      context.commit(SET_FAMILY_ATTRIBUTES, setFamilyAttributesPayload)
    } else if (datasets.length > 0) {
      setFamilyAttributesPayload.family = [...new Set(datasets)]
      context.commit(SET_FAMILY_ATTRIBUTES, setFamilyAttributesPayload)
    } else if (wbTarget.target) {
      // failsafe for audiences created in legacy workbench which may not have rootFamily in the target definition
      setFamilyAttributesPayload.family =
        wbTarget.target === 'xandr_segment' || wbTarget.target === 'adstra' ? ['adstra'] : ['amrld']
      context.commit(SET_FAMILY_ATTRIBUTES, setFamilyAttributesPayload)
    }
  },
  [SET_AVAILABLE_DESTINATIONS]: (context, value) => {
    context.commit(SET_AVAILABLE_DESTINATIONS, value)
  },
  [SET_ATTRIBUTES]: context => {
    let appRes = context.rootState.appRes
    let setUntilDatasetsAreRetrieved = function () {
      setTimeout(() => {
        if (appRes.datasets && appRes.datasetFamilies) {
          context.commit(SET_ATTRIBUTES, appRes.datasets)
          context.commit(SET_DATASET_FAMILY, appRes.datasetFamilies)
          context.dispatch(SET_TARGET_DEFINITION)
        } else {
          setUntilDatasetsAreRetrieved()
        }
      }, 10)
    }
    setUntilDatasetsAreRetrieved()
  },
  [SET_TARGET_DEFINITION]: context => {
    let td = context.state.workbenchTarget.target_definition
    if (td) {
      context.commit(SET_DEFINITION, definitionSerializer.deserialize(td.query))
      context.dispatch(RESET_FAMILY_DATASETS)
    } else {
      context.commit(SET_DEFINITION, definitionSerializer.deserialize([]))
    }
    context.dispatch(INITIALIZE_TARGET_DEF, context.getters.getDefinition)
  },
  [SET_INTERFACE]: (context, inter) => {
    context.commit(SET_INTERFACE, inter)
  },
  [SET_TARGET_CREATE_ACTION]: (context, action) => {
    context.commit(SET_TARGET_CREATE_ACTION, action)
  },
  [SET_TARGET]: (context, targetInfo) => {
    const inter = context.state.interface
    if (!inter) {
      return fetchSingleTarget({ target_id: targetInfo.id }).then(resp => {
        context.commit(SET_TARGET, resp.data)
      })
    } else {
      return context.state.interface.getTarget(targetInfo).then(resp => {
        if (
          targetInfo.advertiser &&
          resp.advertiser &&
          targetInfo.advertiser.Advertiser_id !== resp.advertiser.Advertiser_id
        ) {
          resp = { ...resp, advertiser: { ...targetInfo.advertiser } }
        }
        context.commit(SET_TARGET, resp)
        context.state.interface.onSetTarget(resp, context)
        return resp
      })
    }
  },
  [SET_TARGET_DEFAULT]: (context, defaultTarget) => {
    context.commit(SET_TARGET, defaultTarget)
  },
  [SUBMIT_DOWNSTREAM]: context => {
    context.state.interface.sendDownStream({
      context,
      targetId: context.state.workbenchTarget.id,
    })
    context.commit(SET_ENABLE_DOWN_STREAM, false)
    context.commit(SET_ENABLE_SAVE_BUTTON, false)
    context.commit(SET_VIEW_ONLY, true)
  },
  [ON_CREATE_ACTION]: (context, targetInfo) => {
    context.dispatch(ON_CREATE_REGISTER_MODULES_TO_STORE).then(resp => {
      // context.dispatch(SET_INTERFACE, targetInfo.interface) // this action must fire before any others
      context.dispatch(INITIALIZE_TARGET_DEF, null)
      // TODO_AFTER read below comments
      // not sure if we are going to show the AUP MODAL for all targets or only when the Xandr Trait is selected
      // will leave it here for now
      // dispatch SHOW AUP MODAL should be in Xandr Interface if we choose to only do it for Xandr Traits
      // context.dispatch(SHOW_AUP_MODAL, true)
      if (targetInfo.targetId === 'new') {
        context.dispatch(SET_ATTRIBUTES)
        // TODO_AFTER uncomment when using a target
        let currentTarget = context.rootGetters.currentTarget
          ? context.rootGetters.currentTarget
          : { advertiser: { Name: null }, display_name: '' }
        // let currentTarget = {advertiser: {Name: ""}, display_name: ""}
        // if (!currentTarget.display_name) {
        //   context.commit(SET_ENABLE_SAVE_BUTTON, false)
        // }
        let td = currentTarget.target_definition
        // let td = null
        if (td && td.query && td.query.length > 0) {
          context.state.interface.onDuplicate(context)
        }
        context.dispatch(SET_TARGET_DEFAULT, { ...currentTarget })
      } else {
        context.dispatch(SET_TARGET, targetInfo).then(resp => {
          context.dispatch(SET_ATTRIBUTES)
          const inter = context.state.interface
          if (inter) {
            context.state.interface.onCreate(context)
          }
        })
      }
    })
  },
  [UPDATE_TARGET_DEFINITION_RELATED_INFORMATION]: (context, initialLoad = false) => {
    let inter = context.state.interface
    if (inter) {
      inter.onTargetDefinitionChange({
        context: context,
        targetDefinition: context.getters.newTargetDefinition,
        initialLoad: initialLoad,
      })
    }
  },
  [QUERY_FOR_DATA]: context => {
    let inter = context.state.interface
    return inter
      .queryForData({
        context,
        targetDefinition: context.getters.newTargetDefinition,
        caeId: context.getters.newWorkbenchTarget.cae_id || 0,
      })
      .then(resp => {
        /**
         * @return {slottedValue}
         *  - slottedValue - optional, this will update the Slotted Value in the store
         *  - when there is a failure there will be a statusCode and a message
         */
        if (resp.slottedValue) {
          context.commit(SET_SLOTTED_VALUE, resp.slottedValue)
        }
        return resp
      })
  },
  [SAVE_TARGET]: (context, { target, ignoreSavePrompt }) => {
    if (target && !target.username) {
      target.username = context.rootGetters.username
    }
    const onSave = function () {
      context.commit(SET_ENABLE_DOWN_STREAM, false)
      context.commit(SET_ENABLE_SAVE_BUTTON, false)
      let newTargetDefinition = context.getters.newTargetDefinition
      return context.state.interface
        .saveTarget({
          target,
          context,
          targetDefinition: newTargetDefinition,
          ignoreSavePrompt,
        })
        .then(resp => {
          if (newTargetDefinition.length > 0) {
            context.commit(SET_ENABLE_DOWN_STREAM, true)
          }
        })
        .catch(err => {
          console.log(err)
          context.commit(SET_ENABLE_SAVE_BUTTON, true)
        })
    }
    if (target.id) {
      return onSave()
    } else {
      validateTargetName(target.display_name, target.target)
        .then(resp => {
          if (resp) {
            onSave()
          } else {
            context.commit(SET_ENABLE_SAVE_BUTTON, true)
          }
        })
        .catch(resp => {
          context.commit(SET_ENABLE_SAVE_BUTTON, true)
        })
    }
  },
  [SET_ENABLE_SAVE_BUTTON]: (context, value) => {
    context.commit(SET_ENABLE_SAVE_BUTTON, value)
  },
  [SET_LOADING_WORKBENCH]: (context, value) => {
    context.commit(SET_LOADING_WORKBENCH, value)
  },
  [SET_TARGET_DEFINITION_DIRTY]: (context, value) => {
    context.commit(SET_TARGET_DEFINITION_DIRTY, value)
  },
  [SET_ENABLE_DOWN_STREAM]: (context, value) => {
    context.commit(SET_ENABLE_DOWN_STREAM, value)
  },
  [RESET_STORE]: context => {
    if (context.state.interface) {
      context.state.interface.reset(context)
    }
    context.commit(SET_DEFINITION, [])
    context.dispatch(INITIALIZE_TARGET_DEF, null)
    context.commit(CLEAR_ATTRIBUTES)
    context.commit(RESET_STORE)
    context.commit(SET_VIEW_ONLY, false)
    context.dispatch(ON_RESET_UNREGISTER_MODULES_TO_STORE)
  },
  [INITIALIZE_TARGET_DEF]: (context, targetDef) => {
    context.dispatch(undoActions.INITIALIZE, targetDef)
  },
  [SET_ENABLE_DEFINITION_ACTIONS]: (context, value) => {
    context.commit(SET_ENABLE_DEFINITION_ACTIONS, value)
  },
  [GO_TO_DASHBOARD]: context => {
    context.dispatch(GO_TO_DASHBOARD_ROUTES, null, { root: true })
  },
  [SHOW_AUP_MODAL]: (context, value) => {
    context.commit(SHOW_AUP_MODAL, value)
  },
  [SET_ADVERTISER]: (context, advertiser) => {
    context.commit(SET_ADVERTISER, advertiser)
  },
  [UPDATE_TARGET_NAME]: (context, targetName) => {
    context.commit(UPDATE_TARGET_NAME, targetName)
  },
  [NOTIFY_ADCITY]: (context, targetId) => {
    return notifyAdCity(targetId).then(response => {
      return response
    })
  },
  [MODEL_LAL]: context => {
    context.state.interface.modelLAL(context)
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/common/store/actions.js